import React from "react";

import {
  MDBJumbotron,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBMask,
  MDBView,
} from "mdbreact";

import "./styles.css";

const Service = () => {
  return (
    <MDBJumbotron id="service" className="container-sale w-100">
      <MDBContainer>
        <h2 className="display-5 text-center mb-5">NUESTROS SERVICIOS</h2>
        <MDBRow>
          <MDBCol sm="12" md="6" lg="3" className="mb-5">
            <MDBCard>
              <MDBView className="hover">
                <img
                  src={"/images/inmobiliaria.jpg"}
                  className="img-fluid"
                  alt=""
                />
                <MDBMask className="flex-center" overlay="blue-light">
                  <p className="white-text" style={{ fontSize: "14px" }}>
                    COMPRA Y VENTA DE INMUEBLES
                  </p>
                </MDBMask>
              </MDBView>
            </MDBCard>
          </MDBCol>

          <MDBCol sm="12" md="6" lg="3" className="mb-5">
            <MDBCard>
              <MDBView className="hover">
                <img
                  src={"/images/construccion2.png"}
                  className="img-fluid"
                  alt=""
                />
                <MDBMask className="flex-center" overlay="blue-light">
                  <p className="white-text" style={{ fontSize: "14px" }}>
                    CONSTRUCCIÓN EN OBRAS CIVILES
                  </p>
                </MDBMask>
              </MDBView>
            </MDBCard>
          </MDBCol>

          <MDBCol sm="12" md="6" lg="3" className="mb-5">
            <MDBCard>
              <MDBView className="hover">
                <img
                  src={"/images/licencias.jpg"}
                  className="img-fluid"
                  alt=""
                />
                <MDBMask className="flex-center" overlay="blue-light">
                  <p className="white-text" style={{ fontSize: "14px" }}>
                    LICENCIAS DE CONSTRUCCIÓN
                  </p>
                </MDBMask>
              </MDBView>
            </MDBCard>
          </MDBCol>

          <MDBCol sm="12" md="6" lg="3" className="mb-5">
            <MDBCard>
              <MDBView className="hover">
                <img
                  src={"/images/planos.jpg"}
                  className="img-fluid"
                  alt=""
                />
                <MDBMask className="flex-center" overlay="blue-light">
                  <p className="white-text" style={{ fontSize: "14px" }}>
                    PLANOS Y DISEÑOS
                  </p>
                </MDBMask>
              </MDBView>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBJumbotron>
  );
};

export default Service;
